import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  ClientToolCall,
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'

type ToolName = 'run_file_change_hooks'
export const handleRunFileChangeHooks = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<ToolName>
  requestClientToolCall: (
    toolCall: ClientToolCall<ToolName>,
  ) => Promise<AnvilToolOutput<ToolName>>
}): Promise<{ output: AnvilToolOutput<ToolName> }> => {
  const { previousToolCallFinished, toolCall, requestClientToolCall } = params

  await previousToolCallFinished
  return { output: await requestClientToolCall(toolCall) }
}) satisfies AnvilToolHandlerFunction<'run_file_change_hooks'>
